import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import store from './store';
import { Provider } from 'mobx-react';

// 1、从三方跳过来，存入local
// 2、直接打开如果没有，给默认值---直播
// 3、退出应该清除local
// 4、存入local主要是为了低代码平台中outRequest使用
if (window.name) {
    localStorage.setItem('BI', window.name);
}
const root = createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
